import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.management');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';

type ManagementSection = 'offices' | 'access' | 'stats';

type PlanDefinition = {
    id: string;
    name: string;
    monthlyFee: number;
};

type ManagedOffice = {
    id: string;
    customerName: string;
    planCode: string;
    status: string;
    tenantId: string;
    memberCount: number;
    contractDate: string;
    contractStart: string;
    contractEnd: string;
    managerName: string;
    contact: string;
    email: string;
    createdAt: string;
    updatedAt: string;
};

type OfficeDocument = {
    id: string;
    officeId: string;
    documentType: string;
    title: string;
    name: string;
    size: number;
    contentType: string;
    uploadedAt: string;
    uploadedBy: string;
};

@Component({
    selector: 'wiz-page-management',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.management/view.scss */
:host {
  display: block;
  height: 100%;
}

.ipm-dashboard-summary-card {
  isolation: isolate;
  box-shadow: inset 0 1px 0 #fff !important;
}

/* Management dashboard insight banner */
.ipm-management-insight {
  position: relative;
  min-height: 17.5rem;
  overflow: hidden;
  padding: 1.8rem 1.95rem 1.05rem;
  border: 1px solid rgba(50, 134, 91, 0.62);
  border-radius: 1.15rem;
  background: #073f30;
  box-shadow: 0 20px 42px rgba(15, 72, 46, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  isolation: isolate;
}

.ipm-management-insight::before {
  position: absolute;
  z-index: 4;
  top: 0;
  left: 2rem;
  width: 5rem;
  height: 3px;
  border-radius: 0 0 999px 999px;
  background: #73c75a;
  content: "";
}

.ipm-management-insight::after {
  position: absolute;
  z-index: 1;
  inset: 0;
  background: linear-gradient(90deg, rgba(5, 53, 39, 0.99) 0%, rgba(5, 62, 45, 0.96) 43%, rgba(5, 69, 50, 0.78) 62%, rgba(4, 72, 53, 0.16) 84%, transparent 100%);
  pointer-events: none;
  content: "";
}

.ipm-management-insight__art {
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 49%;
  overflow: hidden;
  pointer-events: none;
}

.ipm-management-insight__art img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 60% 52%;
  filter: saturate(0.82) brightness(0.8) contrast(0.96);
  transform: scale(1.015);
}

.ipm-management-insight__copy,
.ipm-management-insight__metrics {
  position: relative;
  z-index: 2;
}

.ipm-management-insight__copy {
  width: min(60%, 43rem);
}

.ipm-management-insight__eyebrow {
  margin: 0;
  color: #9ae2a4;
  font-size: 0.68rem;
  font-weight: 850;
  line-height: 1.2;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.ipm-management-insight__copy h1 {
  max-width: 43rem;
  margin: 0.75rem 0 0;
  color: #fff;
  font-size: clamp(1.75rem, 2.7vw, 2.25rem);
  font-weight: 850;
  line-height: 1.18;
  letter-spacing: -0.04em;
  word-break: keep-all;
}

.ipm-management-insight__description {
  max-width: 39rem;
  margin: 0.7rem 0 0;
  color: rgba(238, 253, 244, 0.77);
  font-size: 0.82rem;
  line-height: 1.65;
  word-break: keep-all;
}

.ipm-management-insight__cta {
  display: inline-flex;
  min-height: 2.8rem;
  align-items: center;
  justify-content: center;
  gap: 0.72rem;
  margin-top: 1rem;
  padding: 0.65rem 1.1rem;
  border: 1px solid rgba(255, 255, 255, 0.88);
  border-radius: 0.72rem;
  color: #125d3c;
  background: #fbfffc;
  box-shadow: 0 10px 22px rgba(2, 33, 20, 0.2);
  font-size: 0.74rem;
  font-weight: 800;
  line-height: 1;
  transition: color 180ms ease, background-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.ipm-management-insight__cta:hover {
  color: #0c4c30;
  background: #fff;
  box-shadow: 0 14px 28px rgba(2, 33, 20, 0.26);
  transform: translateY(-2px);
}

.ipm-management-insight__cta:focus-visible,
.ipm-management-insight__metric:focus-visible {
  outline: 3px solid rgba(144, 231, 162, 0.68);
  outline-offset: 3px;
}

.ipm-management-insight__cta i {
  font-size: 0.72rem;
}

.ipm-management-insight__metrics {
  display: grid;
  width: min(61%, 45rem);
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.55rem;
  margin-top: 1rem;
}

.ipm-management-insight__metric {
  display: grid;
  min-width: 0;
  min-height: 4rem;
  grid-template-columns: 2.2rem minmax(0, 1fr);
  align-items: center;
  gap: 0.65rem;
  padding: 0.62rem 0.72rem;
  border: 1px solid rgba(218, 250, 226, 0.18);
  border-radius: 0.75rem;
  color: #fff;
  background: rgba(255, 255, 255, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(8px);
  transition: border-color 180ms ease, background-color 180ms ease, transform 180ms ease;
}

.ipm-management-insight__metric:hover {
  border-color: rgba(218, 250, 226, 0.34);
  background: rgba(255, 255, 255, 0.11);
  transform: translateY(-2px);
}

.ipm-management-insight__metric-icon {
  display: grid;
  width: 2.2rem;
  height: 2.2rem;
  place-items: center;
  border: 1px solid rgba(224, 252, 231, 0.14);
  border-radius: 0.58rem;
  color: #dfffe8;
  background: rgba(214, 251, 224, 0.09);
  font-size: 0.8rem;
}

.ipm-management-insight__metric-copy {
  display: block;
  min-width: 0;
}

.ipm-management-insight__metric-copy small {
  display: block;
  overflow: hidden;
  color: rgba(235, 253, 241, 0.72);
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ipm-management-insight__metric-copy strong {
  display: block;
  margin-top: 0.15rem;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 850;
  line-height: 1.1;
  white-space: nowrap;
}

@media (max-width: 1100px) {
  .ipm-management-insight {
    min-height: 18rem;
  }
  .ipm-management-insight__art {
    width: 53%;
    opacity: 0.78;
  }
  .ipm-management-insight__copy {
    width: 68%;
  }
  .ipm-management-insight__metrics {
    width: 74%;
  }
}
@media (max-width: 767px) {
  .ipm-management-insight {
    min-height: auto;
    padding: 1.35rem 1.25rem 1.2rem;
  }
  .ipm-management-insight::before {
    left: 1.25rem;
  }
  .ipm-management-insight::after {
    background: linear-gradient(90deg, rgba(5, 53, 39, 0.99) 0%, rgba(5, 62, 45, 0.95) 67%, rgba(5, 69, 50, 0.82) 100%);
  }
  .ipm-management-insight__art {
    width: 78%;
    opacity: 0.32;
  }
  .ipm-management-insight__copy,
  .ipm-management-insight__metrics {
    width: 100%;
  }
  .ipm-management-insight__copy h1 {
    max-width: 29rem;
    font-size: clamp(1.55rem, 7vw, 2rem);
  }
  .ipm-management-insight__description {
    max-width: 29rem;
  }
}
@media (max-width: 580px) {
  .ipm-management-insight__metrics {
    grid-template-columns: minmax(0, 1fr);
  }
  .ipm-management-insight__metric {
    min-height: 3.6rem;
  }
}`],
})
export class PageManagementComponent implements OnInit, OnDestroy {
    public section: ManagementSection = 'offices';
    public offices: ManagedOffice[] = [];
    public plans: PlanDefinition[] = [
        { id: 'IP-MGMT-A', name: 'A타입', monthlyFee: 100000 },
        { id: 'IP-MGMT-B', name: 'B타입', monthlyFee: 150000 },
        { id: 'IP-MGMT-C', name: 'C타입', monthlyFee: 200000 },
        { id: 'IP-MGMT-D', name: 'D타입', monthlyFee: 200000 }
    ];
    public statuses: string[] = [
        'ACTIVE', 'INVITED', 'PROVISIONING', 'APPROVED', 'DRAFT',
        'FAILED', 'SUSPENDED', 'TERMINATED'
    ];
    public search: any = { text: '', status: '', plan: '' };
    public searchDraft: any = { text: '', status: '', plan: '' };
    public dashboardSummary: any = {
        consultationWaiting: null,
        consultationManaged: null
    };
    public summaryLoading: boolean = true;
    public page: number = 1;
    public pageSize: number = 10;
    public loading: boolean = false;
    public errorMessage: string = '';
    public sourceWarning: string = '';
    public documentsByOffice: { [key: string]: OfficeDocument[] } = {};
    public documentOffice: ManagedOffice | null = null;
    public documentTypes: string[] = ['계약서', '사업자등록증', '견적서', '세금계산서', '기타'];
    public documentForm: { documentType: string; title: string; file: File | null } = {
        documentType: '계약서',
        title: '',
        file: null
    };
    public documentUploading: boolean = false;
    public documentUploadProgress: number = 0;
    private routeSubscription: Subscription = null;
    private readonly maxDocumentFileSize: number = 20 * 1024 * 1024;
    private readonly allowedDocumentExtensions: string[] = [
        '.pdf', '.hwp', '.hwpx', '.doc', '.docx', '.xls', '.xlsx',
        '.ppt', '.pptx', '.txt', '.csv', '.zip', '.jpg', '.jpeg', '.png'
    ];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.syncSectionFromLocation();
        await Promise.all([this.loadOffices(), this.loadDashboardSummary(), this.loadDocuments()]);
        this.routeSubscription = this.router.events.subscribe(async (event) => {
            if (!(event instanceof NavigationEnd)) return;
            this.syncSectionFromLocation();
            await this.service.render();
        });
        await this.service.render();
    }

    public ngOnDestroy() {
        this.routeSubscription?.unsubscribe();
    }

    private syncSectionFromLocation() {
        const requestedSection = new URLSearchParams(location.search).get('section');
        this.section = requestedSection === 'access' || requestedSection === 'stats'
            ? requestedSection
            : 'offices';
    }

    @HostListener('document:keydown.escape')
    public async closeModalOnEscape() {
        if (this.documentOffice) await this.closeDocumentManager();
    }

    public get sectionTitle() {
        if (this.section === 'access') return '접속현황';
        if (this.section === 'stats') return '운영 통계';
        return '회원사 관리';
    }

    public get sectionDescription() {
        if (this.section === 'access') return '실시간 접속 정보 연동 상태를 확인합니다.';
        if (this.section === 'stats') return '실제 등록된 회원사의 개통 상태와 계약 타입을 집계합니다.';
        return 'Core API에 실제 등록된 회원사와 개통 상태를 관리합니다.';
    }

    private responseData(response: any) {
        const payload = response && response.responseJSON ? response.responseJSON : response;
        const status = Number(payload?.code ?? response?.status ?? 500);
        const data = payload?.data;
        if (!payload || status >= 400) {
            const message = data?.error?.message
                || payload?.message
                || (typeof data === 'string' ? data : data?.message)
                || response?.statusText
                || '요청을 처리하지 못했습니다.';
            const requestError: any = new Error(String(message));
            requestError.status = status;
            throw requestError;
        }
        return data;
    }

    private normalizeOffice(row: any): ManagedOffice | null {
        const id = String(row?.id || row?.onboarding_id || '').trim();
        const customerName = String(
            row?.office_name || row?.name || row?.legal_name || row?.organization?.legal_name || ''
        ).trim();
        if (!id || !customerName) return null;
        return {
            id,
            customerName,
            planCode: String(row?.plan_code || row?.contract?.plan_code || '').trim(),
            status: String(
                row?.tenant_status || row?.status || row?.provisioning?.status || 'ACTIVE'
            ).trim().toUpperCase(),
            tenantId: String(row?.tenant_id || row?.provisioning?.tenant_id || row?.id || '').trim(),
            memberCount: Math.max(0, Number(row?.member_count ?? row?.user_count ?? row?.seat_limit ?? 0)),
            contractDate: String(row?.contract_date || row?.contract_created_at || '').trim(),
            contractStart: String(row?.contract_start || row?.contract_started_at || row?.starts_at || '').trim(),
            contractEnd: String(row?.contract_end || row?.contract_ends_at || row?.ends_at || '').trim(),
            managerName: String(row?.manager_name || row?.contact_name || '').trim(),
            contact: String(row?.contact || row?.phone || '').trim(),
            email: String(row?.email || '').trim().toLowerCase(),
            createdAt: String(row?.created_at || '').trim(),
            updatedAt: String(row?.updated_at || '').trim()
        };
    }

    private errorText(error: any, fallback: string) {
        const payload = error?.responseJSON || error;
        return String(
            payload?.data?.error?.message
            || payload?.data?.message
            || payload?.message
            || payload?.statusText
            || fallback
        );
    }

    private errorStatus(error: any) {
        return Number(
            error?.responseJSON?.code
            ?? error?.code
            ?? error?.status
            ?? 0
        );
    }

    public async loadOffices() {
        this.loading = true;
        this.errorMessage = '';
        this.sourceWarning = '';
        await this.service.render();
        try {
            const first = this.responseData(await wiz.call('list_offices', { page: 1 }));
            this.sourceWarning = String(first?.warning || '');
            const rows: any[] = Array.isArray(first?.items) ? first.items.slice() : [];
            const totalPages = Math.max(1, Number(first?.pagination?.total_pages || 1));
            for (let page = 2; page <= totalPages; page += 1) {
                const next = this.responseData(await wiz.call('list_offices', { page }));
                if (Array.isArray(next?.items)) rows.push(...next.items);
            }
            this.offices = rows
                .map((row) => this.normalizeOffice(row))
                .filter((row): row is ManagedOffice => row !== null);
            this.page = 1;
        } catch (error) {
            this.offices = [];
            this.sourceWarning = '';
            if (this.errorStatus(error) === 401) {
                this.service.href('/access');
                return;
            }
            this.errorMessage = this.errorText(error, '실제 회원사 목록을 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadDashboardSummary() {
        this.summaryLoading = true;
        await this.service.render();
        try {
            const data = this.responseData(await wiz.call('dashboard_summary'));
            this.dashboardSummary = {
                consultationWaiting: data?.consultation_waiting !== null
                    && data?.consultation_waiting !== undefined
                    && Number.isFinite(Number(data.consultation_waiting))
                    ? Number(data.consultation_waiting)
                    : null,
                consultationManaged: data?.consultation_managed !== null
                    && data?.consultation_managed !== undefined
                    && Number.isFinite(Number(data.consultation_managed))
                    ? Number(data.consultation_managed)
                    : null
            };
        } catch (_error) {
            this.dashboardSummary = { consultationWaiting: null, consultationManaged: null };
        } finally {
            this.summaryLoading = false;
            await this.service.render();
        }
    }

    public get filteredOffices() {
        const text = this.search.text.trim().toLowerCase();
        return this.offices.filter((office) => {
            const searchable = [
                office.customerName,
                office.tenantId,
                office.planCode,
                office.managerName,
                office.contact,
                office.email
            ]
                .join(' ')
                .toLowerCase();
            const textMatched = !text || searchable.includes(text);
            const statusMatched = !this.search.status || office.status === this.search.status;
            const planMatched = !this.search.plan || office.planCode === this.search.plan;
            return textMatched && statusMatched && planMatched;
        });
    }

    public get paginatedOffices() {
        const start = (this.page - 1) * this.pageSize;
        return this.filteredOffices.slice(start, start + this.pageSize);
    }

    public get pageCount() {
        return Math.max(1, Math.ceil(this.filteredOffices.length / this.pageSize));
    }

    public get pageNumbers() {
        return Array.from({ length: this.pageCount }, (_, index) => index + 1);
    }

    public get activeOfficeCount() {
        return this.offices.filter((office) => office.status === 'ACTIVE').length;
    }

    public get onboardingOfficeCount() {
        return this.offices.filter((office) => ['DRAFT', 'APPROVED', 'PROVISIONING', 'INVITED'].includes(office.status)).length;
    }

    public get managementNeededCount() {
        return this.offices.filter((office) => ['FAILED', 'SUSPENDED', 'TERMINATED'].includes(office.status)).length;
    }

    public get statisticCards() {
        return [
            { label: '전체 등록', value: this.offices.length + '곳', detail: 'Core API 온보딩 기준' },
            { label: '활성 회원사', value: this.activeOfficeCount + '곳', detail: '정상 개통 완료' },
            { label: '개통 진행', value: this.onboardingOfficeCount + '곳', detail: '초안·승인·초대 포함' },
            { label: '관리 필요', value: this.managementNeededCount + '곳', detail: '실패·중지·종료 상태' }
        ];
    }

    public get planStatistics() {
        const total = Math.max(1, this.offices.length);
        return this.plans.map((plan) => {
            const offices = this.offices.filter((office) => office.planCode === plan.id).length;
            return { name: plan.name, offices, rate: Math.round((offices / total) * 100) };
        });
    }

    public get statusStatistics() {
        return this.statuses
            .map((status) => ({ status, count: this.offices.filter((office) => office.status === status).length }))
            .filter((item) => item.count > 0);
    }

    public async resetPage() {
        this.page = 1;
        await this.service.render();
    }

    public async applySearch() {
        this.search = { ...this.searchDraft };
        this.page = 1;
        await this.service.render();
    }

    public async clearSearch() {
        this.search = { text: '', status: '', plan: '' };
        this.searchDraft = { text: '', status: '', plan: '' };
        this.page = 1;
        await this.service.render();
    }

    public async goToPage(page: number) {
        this.page = Math.min(Math.max(page, 1), this.pageCount);
        await this.service.render();
    }

    public pageButtonClass(pageNumber: number) {
        if (pageNumber === this.page) {
            return 'inline-flex size-8 items-center justify-center rounded-md border border-emerald-700 bg-emerald-700 text-[11px] font-semibold text-white';
        }
        return 'inline-flex size-8 items-center justify-center rounded-md border border-slate-200 bg-white text-[11px] font-semibold text-slate-600 hover:bg-slate-50';
    }

    public statusLabel(status: string) {
        return {
            ACTIVE: '정상',
            INVITED: '초대 대기',
            PROVISIONING: '개통 중',
            APPROVED: '승인 완료',
            DRAFT: '계약 초안',
            FAILED: '처리 실패',
            SUSPENDED: '중지',
            TERMINATED: '종료'
        }[status] || status || '-';
    }

    public statusClass(status: string) {
        if (status === 'ACTIVE') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (['FAILED', 'SUSPENDED', 'TERMINATED'].includes(status)) return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-amber-200 bg-amber-50 text-amber-700';
    }

    public planName(code: string) {
        return this.plans.find((plan) => plan.id === code)?.name || code || '-';
    }

    public monthlyQuote(office: ManagedOffice) {
        return this.plans.find((plan) => plan.id === office.planCode)?.monthlyFee || 0;
    }

    public displayDate(value: string) {
        return value ? value.slice(0, 10) : '-';
    }

    public contractPeriod(office: ManagedOffice) {
        const start = this.displayDate(office.contractStart);
        const end = this.displayDate(office.contractEnd);
        if (start === '-' && end === '-') return '-';
        return start + ' ~ ' + end;
    }

    private async loadDocuments() {
        try {
            const data = this.responseData(await wiz.call('list_documents'));
            this.documentsByOffice = data && typeof data === 'object' ? data : {};
        } catch (error) {
            this.documentsByOffice = {};
        }
    }

    public documentsFor(officeId: string): OfficeDocument[] {
        return this.documentsByOffice[officeId] || [];
    }

    public documentCount(officeId: string) {
        return this.documentsFor(officeId).length;
    }

    public async openDocumentManager(office: ManagedOffice) {
        this.documentOffice = office;
        this.documentForm = { documentType: '계약서', title: '', file: null };
        this.documentUploadProgress = 0;
        await this.service.render();
    }

    public async closeDocumentManager() {
        if (this.documentUploading) return;
        this.documentOffice = null;
        this.documentForm = { documentType: '계약서', title: '', file: null };
        this.documentUploadProgress = 0;
        await this.service.render();
    }

    public async selectDocumentFile(event: any) {
        const file = event?.target?.files?.[0] as File;
        if (event?.target) event.target.value = '';
        if (!file) return;

        const dot = file.name.lastIndexOf('.');
        const extension = dot >= 0 ? file.name.slice(dot).toLowerCase() : '';
        if (!this.allowedDocumentExtensions.includes(extension)) {
            await this.service.modal.error('지원하지 않는 파일 형식입니다.');
            return;
        }
        if (file.size > this.maxDocumentFileSize) {
            await this.service.modal.error('파일 크기는 20MB를 초과할 수 없습니다.');
            return;
        }

        this.documentForm.file = file;
        if (!this.documentForm.title.trim()) {
            this.documentForm.title = dot > 0 ? file.name.slice(0, dot) : file.name;
        }
        await this.service.render();
    }

    public async clearDocumentFile() {
        this.documentForm.file = null;
        await this.service.render();
    }

    public async uploadDocument() {
        if (!this.documentOffice || !this.documentForm.file || this.documentUploading) {
            if (!this.documentForm.file) await this.service.modal.error('업로드할 서류 파일을 선택해주세요.');
            return;
        }

        this.documentUploading = true;
        this.documentUploadProgress = 0;
        await this.service.render();
        try {
            const form = new FormData();
            form.append('office_id', this.documentOffice.id);
            form.append('document_type', this.documentForm.documentType);
            form.append('title', this.documentForm.title.trim());
            form.append('file', this.documentForm.file);
            const response = await this.service.file.upload(
                wiz.url('upload_document'),
                form,
                async (percent: number) => {
                    this.documentUploadProgress = percent;
                    await this.service.render();
                }
            );
            const saved: OfficeDocument = this.responseData(response);
            this.documentsByOffice[this.documentOffice.id] = [saved, ...this.documentsFor(this.documentOffice.id)];
            this.documentForm = { documentType: '계약서', title: '', file: null };
            this.documentUploadProgress = 100;
        } catch (error) {
            await this.service.modal.error(String(error?.message || '서류를 업로드하지 못했습니다.'));
        } finally {
            this.documentUploading = false;
            await this.service.render();
        }
    }

    public async deleteDocument(document: OfficeDocument) {
        if (!this.documentOffice || this.documentUploading) return;
        const confirmed = await this.service.modal.show({
            title: '회원사 서류 삭제',
            message: '“' + document.title + '” 서류를 삭제하시겠습니까?\n삭제한 파일은 복구할 수 없습니다.',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        try {
            const deleted = this.responseData(await wiz.call('delete_document', {
                office_id: this.documentOffice.id,
                document_id: document.id
            }));
            this.documentsByOffice[this.documentOffice.id] = this.documentsFor(this.documentOffice.id)
                .filter((item) => item.id !== deleted.id);
        } catch (error) {
            await this.service.modal.error(String(error?.message || '서류를 삭제하지 못했습니다.'));
        }
        await this.service.render();
    }

    public downloadDocument(document: OfficeDocument) {
        if (!this.documentOffice) return;
        const query = new URLSearchParams({
            office_id: this.documentOffice.id,
            document_id: document.id
        });
        window.open(wiz.url('download_document') + '?' + query.toString(), '_blank', 'noopener,noreferrer');
    }

    public formatDocumentSize(size: number) {
        const bytes = Number(size || 0);
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }
}

export default PageManagementComponent;